import { render } from "./calendarEventpopover.vue?vue&type=template&id=1456c366"
import script from "./calendarEventpopover.vue?vue&type=script&lang=js"
export * from "./calendarEventpopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__